import React from "react";
//#region  types
import { EntityNavigationCardContentProps } from "models/propTypes/navigationPropTypes";
import { DisplayType } from "models/enums/style";
//#endregion
//#region  components
import { Grid } from "@mui/material";
import useMountedState from "../useMountedState";
import StyledButton from "../buttons/styledButton";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const EntityNavigationCardContent: React.FC<EntityNavigationCardContentProps> = (props) => {
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const { getMounted } = useMountedState();

  const onClick = () => {
    if (props.onClick) {
      setIsSubmitting(true);

      props.onClick().finally(() => {
        getMounted() && setIsSubmitting(false);
      });
    }
  };

  return (
    <>
      <Grid item xs container className={cssExports.entityNavigationCardBody} direction="column">
        <Grid item className={cssExports.navigationCardTitle}>
          {props.title}
        </Grid>
        <Grid item className={cssExports.navigationCardSubTitle}>
          {props.subtitle}
        </Grid>
        <Grid item className={clsx(cssExports.navigationCardSubDescription, cssExports.slightlyColorChangedText)}>
          {props.description}
        </Grid>
      </Grid>
      <Grid item container className={cssExports.entityNavigationCardFooter} wrap="nowrap" alignItems="flex-end">
        <Grid item xs className={clsx(cssExports.entityNavigationCardFooterText, cssExports.slightlyColorChangedText)}>
          {props.footerText}
        </Grid>
        <Grid item>
          {props.showButton && (
            <>
              {props.displayType === DisplayType.None ? (
                <StyledButton size="xs" onClick={onClick} secondary isSubmitting={isSubmitting}>
                  {props.buttonText}
                </StyledButton>
              ) : (
                <StyledButton size="xs" onClick={onClick} displayType={props.displayType} isSubmitting={isSubmitting}>
                  {props.buttonText}
                </StyledButton>
              )}
            </>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default EntityNavigationCardContent;
